import React from 'react'
import { ButtonCtaProps } from '../../../ui-lib/button'
import { LlamaUnsupportedOSButton } from './base'
import { WindowsDownloadButton } from './windows'
import { MacDownloadButton } from './mac'
import { InstallType, llamaInstallTypes, useFirstEligibleInstall } from '../../../../lib/hooks/install-eligibility'

export interface LlamaDownloadButtonProps extends Omit<ButtonCtaProps, 'onClick'> {
  onClick?: () => void
}

export const LlamaDownloadButton: React.FC<LlamaDownloadButtonProps> = (props) => {
  const preferredInstall = useFirstEligibleInstall(llamaInstallTypes)

  if (preferredInstall === InstallType.Windows) {
    return <WindowsDownloadButton {...props} />
  } else if (preferredInstall === InstallType.Mac) {
    return <MacDownloadButton {...props} />
  } else {
    return <LlamaUnsupportedOSButton {...props} />
  }
}
